export const name = "LN";
export const summary = `Computes the natural logarithm of \`X\`.`;
export const reference = `
## LN

Computes the natural logarithm of \`X\`.

\`\`\`
LN(X)
\`\`\`

### Description

Computes the natural logarithm of X. Generates an error if X is less than or equal to zero.

| X | LN(X) |
| --- | --- |
| 1.0 | 0.0 |
| \`+inf\` | \`+inf\` |
| \`X <= 0\` | Error |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
